import { render, staticRenderFns } from "./ContactPopUp.vue?vue&type=template&id=4ce45ed4&scoped=true&"
import script from "./ContactPopUp.vue?vue&type=script&lang=js&"
export * from "./ContactPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ContactPopUp.vue?vue&type=style&index=0&id=4ce45ed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce45ed4",
  null
  
)

export default component.exports